/* eslint-disable no-unused-vars */
import React, { lazy, Suspense, useEffect } from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import { connect } from 'react-redux'

import Layout from './layouts'
import { getListadoMenuByUsuarioIdAction } from '@redux//menu/actions'
import { useMsal } from '@azure/msal-react'
import { getPermisosMenuKeyUsuarioByIdAction } from '@redux//usuario/actions'
import ProtectedRoute from './protectedRoute'
import ChunkErrorBoundary from 'components/chunk-error-boundary'

const routes = [
  // Dashboards
  {
    keyMenu: '', // Esta key es genericay de uso para todos lo usuarios
    path: '/dashboard/regalo',
    Component: lazy(() => import('pages/dashboard/regalo')),
    exact: true,
  },
  {
    path: '/dashboard/alpha',
    Component: lazy(() => import('pages/dashboard/alpha')),
    exact: true,
  },
  {
    path: '/dashboard/beta',
    Component: lazy(() => import('pages/dashboard/beta')),
    exact: true,
  },
  {
    path: '/dashboard/gamma',
    Component: lazy(() => import('pages/dashboard/gamma')),
    exact: true,
  },
  {
    path: '/dashboard/crypto',
    Component: lazy(() => import('pages/dashboard/crypto')),
    exact: true,
  },

  // Auth Pages
  /*
  {
    path: '/auth/login',
    Component: lazy(() => import('pages/auth/login')),
    exact: true,
  },
  {
    path: '/auth/forgot-password',
    Component: lazy(() => import('pages/auth/forgot-password')),
    exact: true,
  },
  {
    path: '/auth/register',
    Component: lazy(() => import('pages/auth/register')),
    exact: true,
  },
  {
    path: '/auth/lockscreen',
    Component: lazy(() => import('pages/auth/lockscreen')),
    exact: true,
  },
  {
    path: '/auth/callback',
    Component: lazy(() => import('pages/auth/callback')),
    exact: true,
  },
  {
    path: '/auth/logout',
    Component: lazy(() => import('pages/auth/logout')),
    exact: true,
  },
  */
  {
    keyMenu: '', // Esta key es genericay de uso para todos lo usuarios
    path: '/auth/401',
    Component: lazy(() => import('pages/auth/401')),
    exact: true,
  },
  {
    keyMenu: '', // Esta key es genericay de uso para todos lo usuarios
    path: '/auth/403',
    Component: lazy(() => import('pages/auth/403')),
    exact: true,
  },
  {
    keyMenu: '', // Esta key es genericay de uso para todos lo usuarios
    path: '/auth/404',
    Component: lazy(() => import('pages/auth/404')),
    exact: true,
  },
  {
    keyMenu: '', // Esta key es genericay de uso para todos lo usuarios
    path: '/auth/500',
    Component: lazy(() => import('pages/auth/500')),
    exact: true,
  },

  // Productos
  {
    keyMenu: 'productos',
    path: '/productos/edit/:id?',
    Component: lazy(() => import('pages/productos/insert')),
    exact: true,
  },
  {
    keyMenu: 'productos',
    path: '/productos/create',
    Component: lazy(() => import('pages/productos/insert')),
    exact: true,
  },
  {
    keyMenu: 'productos',
    path: '/productos/list',
    Component: lazy(() => import('pages/productos/list')),
    exact: true,
  },
  {
    keyMenu: 'productos',
    path: '/productos/recuperar',
    Component: lazy(() => import('pages/productos/recuperar/list')),
    exact: true,
  },
  {
    keyMenu: 'productos',
    path: '/productos/ordenarAdicionales',
    Component: lazy(() => import('pages/productos/ordenarAdicionales/list')),
    exact: true,
  },
  {
    keyMenu: 'productos',
    path: '/productos/ordenar/:categoriaId?',
    Component: lazy(() => import('pages/productos/ordenar/list')),
    exact: true,
  },

  // Producto Generico
  {
    keyMenu: 'productosGenericos',
    path: '/productogenerico/list',
    Component: lazy(() => import('pages/productoGenerico/list')),
    exact: true,
  },

  // Producto Generico Boceto
  {
    keyMenu: 'productosGenericos',
    path: '/productogenericoboceto/list/:idGen?/:idBoc?',
    Component: lazy(() => import('pages/productoGenericoBoceto/list')),
    exact: true,
  },

  // Producto Generico Boceto Posicion
  {
    keyMenu: 'productosGenericos',
    path: '/productogenericobocetoposicion/list/:id?',
    Component: lazy(() => import('pages/productoGenericoBocetoPosicion/list')),
    exact: true,
  },

  // Productos Desayuno
  {
    keyMenu: 'productosDesayuno',
    path: '/productosdesayuno/list',
    Component: lazy(() => import('pages/productosdesayuno/list')),
    exact: true,
  },

  // Productos En caja
  {
    keyMenu: 'productosEnCaja',
    path: '/productosencaja/list',
    Component: lazy(() => import('pages/productosencaja/list')),
    exact: true,
  },

  // Descuentos
  {
    keyMenu: 'descuentos',
    path: '/descuentos/list',
    Component: lazy(() => import('pages/descuentos/list')),
    exact: true,
  },
  {
    keyMenu: 'descuentos',
    path: '/descuentos/edit/:id?',
    Component: lazy(() => import('pages/descuentos/insert')),
    exact: true,
  },
  {
    keyMenu: 'descuentos',
    path: '/descuentos/create',
    Component: lazy(() => import('pages/descuentos/insert')),
    exact: true,
  },

  // Imagen Descuento
  {
    keyMenu: 'imagenDescuentos',
    path: '/imagen-descuento/list',
    Component: lazy(() => import('pages/imagenDescuento/list')),
    exact: true,
  },
  {
    keyMenu: 'imagenDescuentos',
    path: '/imagen-descuento/create',
    Component: lazy(() => import('pages/imagenDescuento/insert')),
    exact: true,
  },

  // Observaciones
  {
    keyMenu: 'observaciones',
    path: '/observaciones/list',
    Component: lazy(() => import('pages/observaciones/list')),
    exact: true,
  },

  // Categorias
  {
    keyMenu: 'categorias',
    path: '/categorias/edit/:id?',
    Component: lazy(() => import('pages/categorias/insert')),
    exact: true,
  },
  {
    keyMenu: 'categorias',
    path: '/categorias/create',
    Component: lazy(() => import('pages/categorias/insert')),
    exact: true,
  },
  {
    keyMenu: 'categorias',
    path: '/categorias/list',
    Component: lazy(() => import('pages/categorias/list')),
    exact: true,
  },

  // Categorias personalizados
  {
    keyMenu: 'categoriasPersonalizacion',
    path: '/categoriaPersonalizados/list',
    Component: lazy(() => import('pages/categoriaPersonalizados/list')),
    exact: true,
  },

  // Urls
  {
    keyMenu: 'urls',
    path: '/urls/list',
    Component: lazy(() => import('pages/urls/list')),
    exact: true,
  },
  {
    keyMenu: 'urls',
    path: '/urls/edit/:id?',
    Component: lazy(() => import('pages/urls/insert')),
    exact: true,
  },
  {
    keyMenu: 'urls',
    path: '/urls/create',
    Component: lazy(() => import('pages/urls/insert')),
    exact: true,
  },
  {
    keyMenu: 'urls',
    path: '/urls/adicionales/:id?',
    Component: lazy(() => import('pages/urls/adicionales')),
    exact: true,
  },
  {
    keyMenu: 'urls',
    path: '/urls/fotos/:id?',
    Component: lazy(() => import('pages/urls/fotos/list')),
    exact: true,
  },
  {
    keyMenu: 'urls',
    path: '/urls/ordenarProductos/:categoriaId?',
    Component: lazy(() => import('pages/urls/ordenarProductos/list')),
    exact: true,
  },
  {
    keyMenu: 'urls',
    path: '/urls/ordenarProductosTabla/:categoriaId?',
    Component: lazy(() => import('pages/urls/ordenarProductosTabla/list')),
    exact: true,
  },
  {
    keyMenu: 'urls',
    path: '/urls/recuperar',
    Component: lazy(() => import('pages/urls/recuperar')),
    exact: true,
  },
  {
    keyMenu: 'urls',
    path: '/urls/multimedia/:tipo?',
    Component: lazy(() => import('pages/urls/multimedia/list')),
    exact: true,
  },

  // Url Grupos
  {
    keyMenu: 'urlGrupos',
    path: '/urlGrupos/list',
    Component: lazy(() => import('pages/urlGrupos/list')),
    exact: true,
    props: { tipoGrupo: 1 },
  },

  // Url Grupos Diseño
  {
    keyMenu: 'urlGruposDiseno',
    path: '/urlGruposDiseno/list',
    Component: lazy(() => import('pages/urlGrupos/list')),
    exact: true,
    props: { tipoGrupo: 2 },
  },

  // Provincias
  {
    keyMenu: 'provincias',
    path: '/provincias/list',
    Component: lazy(() => import('pages/provincias/list')),
    exact: true,
  },

  // FechasSenaladas
  {
    keyMenu: 'fechasSenaladas',
    path: '/fechaSenalada/list',
    Component: lazy(() => import('pages/fechaSenalada/list')),
    exact: true,
  },
  {
    keyMenu: 'fechasSenaladas',
    path: '/fechaSenalada/edit/:id?',
    Component: lazy(() => import('pages/fechaSenalada/insert')),
    exact: true,
  },
  {
    keyMenu: 'fechasSenaladas',
    path: '/fechaSenalada/create',
    Component: lazy(() => import('pages/fechaSenalada/insert')),
    exact: true,
  },
  {
    keyMenu: 'fechasSenaladas',
    path: '/fechaSenaladaUrl/edit/:fechaId?',
    Component: lazy(() => import('pages/fechaSenaladaUrl/list')),
    exact: true,
  },
  {
    keyMenu: 'fechasSenaladas',
    path: '/fechaSenaladaUrl/ordenar/:fechaId?',
    Component: lazy(() => import('pages/fechaSenaladaUrl/ordenar')),
    exact: true,
  },

  // Fecha Color
  {
    keyMenu: 'fechasColor',
    path: '/fechaColor/list',
    Component: lazy(() => import('pages/fechaColor/list')),
    exact: true,
  },

  // Etiquetas
  {
    keyMenu: 'etiquetas',
    path: '/etiquetas/list/:padreId?',
    Component: lazy(() => import('pages/etiquetas/list')),
    exact: true,
  },
  {
    keyMenu: 'etiquetas',
    path: '/etiquetas/create',
    Component: lazy(() => import('pages/etiquetas/insert')),
    exact: true,
  },
  {
    keyMenu: 'etiquetas',
    path: '/etiquetas/edit/:id?',
    Component: lazy(() => import('pages/etiquetas/insert')),
    exact: true,
  },
  {
    keyMenu: 'etiquetas',
    path: '/etiquetasUrl/edit/:etiquetaId?',
    Component: lazy(() => import('pages/etiquetaUrl/list')),
    exact: true,
  },
  {
    keyMenu: 'etiquetas',
    path: '/etiquetasUrl/ordenar/:etiquetaId?',
    Component: lazy(() => import('pages/etiquetaUrl/ordenar')),
    exact: true,
  },

  // Fechas No Entrega
  {
    keyMenu: 'fechasNoEntrega',
    path: '/fechasNoEntrega/list',
    Component: lazy(() => import('pages/fechaNoEntrega/list')),
    exact: true,
  },
  {
    keyMenu: 'fechasNoEntrega',
    path: '/fechasNoEntrega/categoriasPersonalizacion/:fechaId?',
    Component: lazy(() => import('pages/fechaNoEntrega/categoriasPersonalizacion')),
    exact: true,
  },
  {
    keyMenu: 'fechasNoEntrega',
    path: '/fechasNoEntrega/categoriaPersonalizacionDiaria',
    Component: lazy(() => import('pages/fechaNoEntrega/categoriaPersonalizacionDiaria')),
    exact: true,
  },

  // Fechas Bloqueadas
  {
    keyMenu: 'fechasBloqueadas',
    path: '/fechasBloqueadas/list',
    Component: lazy(() => import('pages/fechaBloqueada/list')),
    exact: true,
  },
  {
    keyMenu: 'fechasBloqueadas',
    path: '/fechasBloqueadas/fechaBloqueadaProvincia/:fechaId?',
    Component: lazy(() => import('pages/fechaBloqueada/fechaBloqueadaProvincia')),
    exact: true,
  },

  // Franja Horarios
  {
    keyMenu: 'franjasHorarios',
    path: '/franjaHorario/list',
    Component: lazy(() => import('pages/franjaHorario/list')),
    exact: true,
  },
  {
    keyMenu: 'franjasHorarios',
    path: '/franjaHorario/fechaHorarios/:limitarHorarioId?',
    Component: lazy(() => import('pages/franjaHorario/fechaHorarios/list')),
    exact: true,
  },

  // Dias Especiales
  {
    keyMenu: 'diasEspeciales',
    path: '/diasEspeciales/list',
    Component: lazy(() => import('pages/diasEspeciales/list')),
    exact: true,
  },
  {
    keyMenu: 'diasEspeciales',
    path: '/diasEspeciales/diaEspecialHorarios/:diaEspecialId?',
    Component: lazy(() => import('pages/diasEspeciales/diaEspecialHorarios/list')),
    exact: true,
  },

  // Caso 3 Bis
  {
    keyMenu: 'caso3bis',
    path: '/caso3bis/list',
    Component: lazy(() => import('pages/caso3bis/list')),
    exact: true,
  },

  // Codigos Postales Conflictivos
  {
    keyMenu: 'codigosPostalesConflictivos',
    path: '/codigosPostalesConflictivos/list',
    Component: lazy(() => import('pages/codigosPostalesConflictivos/list')),
    exact: true,
  },

  // Paises
  {
    keyMenu: 'paises',
    path: '/paises/list',
    Component: lazy(() => import('pages/paises/list')),
    exact: true,
  },

  // Codigos postales
  {
    keyMenu: 'codigoPostal',
    path: '/codigoPostal/list',
    Component: lazy(() => import('pages/codigoPostal/list')),
    exact: true,
  },
  // Codigos postales internacional
  {
    keyMenu: 'codigosPostalesInternacionales',
    path: '/codigosPostalesInternacionales/list',
    Component: lazy(() => import('pages/codigosPostalesInternacionales/list')),
    exact: true,
  },

  // Restricciones de Entrega
  {
    keyMenu: 'restriccionentrega',
    path: '/restriccionentrega/edit/:id?',
    Component: lazy(() => import('pages/restriccionentrega/insert')),
    exact: true,
  },
  {
    keyMenu: 'restriccionentrega',
    path: '/restriccionentrega/create',
    Component: lazy(() => import('pages/restriccionentrega/insert')),
    exact: true,
  },
  {
    keyMenu: 'restriccionentrega',
    path: '/restriccionentrega/list',
    Component: lazy(() => import('pages/restriccionentrega/list')),
    exact: true,
  },

  // Relacion Horarios Madrid (HorarioEntregaMadrid)
  {
    keyMenu: 'horarioEntregaMadrid',
    path: '/horarioEntregaMadrid/list',
    Component: lazy(() => import('pages/horarioEntregaMadrid/list')),
    exact: true,
  },

  // Carteles
  {
    keyMenu: 'carteles',
    path: '/carteles/list',
    Component: lazy(() => import('pages/carteles/list')),
    exact: true,
  },
  {
    keyMenu: 'carteles',
    path: '/carteles/editarUrls/:id?',
    Component: lazy(() => import('pages/carteles/cartelesUrls/list')),
    exact: true,
  },

  // Consulta Email
  {
    keyMenu: 'consultaEmail',
    path: '/consultaEmail/list',
    Component: lazy(() => import('pages/consultaEmail/list')),
    exact: true,
  },

  // Articulos
  {
    keyMenu: 'articulos',
    path: '/articulos/list',
    Component: lazy(() => import('pages/articulos/list')),
    exact: true,
  },
  {
    keyMenu: 'articulos',
    path: '/articulos/edit/:id?',
    Component: lazy(() => import('pages/articulos/insert')),
    exact: true,
  },
  {
    keyMenu: 'articulos',
    path: '/articulos/create',
    Component: lazy(() => import('pages/articulos/insert')),
    exact: true,
  },
  {
    keyMenu: 'articulos',
    path: '/articulos/editarProductos/:id?',
    Component: lazy(() => import('pages/articulos/articulosProductos/list')),
    exact: true,
  },

  // Articulos faltantes
  {
    keyMenu: 'articulosFaltantes',
    path: '/articulos/sinStock/',
    Component: lazy(() => import('pages/articulos/faltantes/list')),
    exact: true,
  },

  // Alta stock
  {
    keyMenu: 'stock',
    path: '/articulos/stock/',
    Component: lazy(() => import('pages/articulos/stock')),
    exact: true,
  },

  {
    path: '/articulos/vendidos/',
    Component: lazy(() => import('pages/articulos/articulosVendidos/list')),
    exact: true,
  },
  // Frutas
  {
    keyMenu: 'frutas',
    path: '/frutas/list',
    Component: lazy(() => import('pages/frutas/list')),
    exact: true,
  },

  // Proveedores
  {
    keyMenu: 'proveedores',
    path: '/proveedores/list',
    Component: lazy(() => import('pages/proveedores/list')),
    exact: true,
  },
  {
    keyMenu: 'proveedores',
    path: '/proveedores/edit/:id?',
    Component: lazy(() => import('pages/proveedores/insert')),
    exact: true,
  },
  {
    keyMenu: 'proveedores',
    path: '/proveedores/create',
    Component: lazy(() => import('pages/proveedores/insert')),
    exact: true,
  },

  // Banner
  {
    keyMenu: 'menuBanner',
    path: '/banner/list',
    Component: lazy(() => import('pages/banner/list')),
    exact: true,
  },
  {
    keyMenu: 'menuBanner',
    path: '/banner/edit/:id?',
    Component: lazy(() => import('pages/banner/insert')),
    exact: true,
  },
  {
    keyMenu: 'menuBanner',
    path: '/banner/create/:idiomaId?',
    Component: lazy(() => import('pages/banner/insert')),
    exact: true,
  },

  // Menu Categorias Configuracion
  {
    keyMenu: 'menuCategoriasConfig',
    path: '/categoriaHome/configuracion',
    Component: lazy(() => import('pages/categoriaHome/configuracion')),
    exact: true,
  },

  // Menu Categoria Seleccion
  {
    keyMenu: 'menuCategoriasSeleccion',
    path: '/categoriaHome/menu',
    Component: lazy(() => import('pages/categoriaHome/menu')),
    exact: true,
  },
  {
    keyMenu: 'menuCategoriasSeleccion',
    path: '/categoriaHome/ordenar/:idiomaId?',
    Component: lazy(() => import('pages/categoriaHome/ordenar')),
    exact: true,
  },
  {
    keyMenu: 'menuCategoriasEspecial',
    path: '/categoriaHome/especial',
    Component: lazy(() => import('pages/categoriaHome/especial')),
    exact: true,
  },

  // Menu Productos Semana
  {
    keyMenu: 'menuProductosSemana',
    path: '/productosSemana/menu',
    Component: lazy(() => import('pages/productosSemana/menu')),
    exact: true,
  },
  {
    keyMenu: 'menuProductosSemana',
    path: '/productosSemana/ordenar/:idiomaId?',
    Component: lazy(() => import('pages/productosSemana/ordenar')),
    exact: true,
  },

  // Menu Sitio
  {
    keyMenu: 'menuSitio',
    path: '/menuSitio/list',
    Component: lazy(() => import('pages/menuSitio/list')),
    exact: true,
  },
  {
    keyMenu: 'menuSitio',
    path: '/menuSitio/edit/:id?',
    Component: lazy(() => import('pages/menuSitio/insert')),
    exact: true,
  },
  {
    keyMenu: 'menuSitio',
    path: '/menuSitio/create/:menuId?',
    Component: lazy(() => import('pages/menuSitio/insert')),
    exact: true,
  },

  // Traduccion Pagina
  {
    keyMenu: 'traduccionPagina',
    path: '/traduccionPagina/list',
    Component: lazy(() => import('pages/traduccionPagina/list')),
    exact: true,
  },
  {
    keyMenu: 'traduccionPagina',
    path: '/traduccionPagina/edit/:id?',
    Component: lazy(() => import('pages/traduccionPagina/insert')),
    exact: true,
  },

  // Generar Mapa
  {
    keyMenu: 'generarMapa',
    path: '/generarMapa/list',
    Component: lazy(() => import('pages/generarMapa/list')),
    exact: true,
  },

  // Pagina OK Template
  {
    keyMenu: 'paginaOk',
    path: '/paginaOkTemplate/list',
    Component: lazy(() => import('pages/paginaOkTemplate/list')),
    exact: true,
  },
  {
    keyMenu: 'paginaOk',
    path: '/paginaOkTemplate/pagina/:paginaId?',
    Component: lazy(() => import('pages/paginaOkTemplate/pagina')),
    exact: true,
  },
  {
    keyMenu: 'paginaOk',
    path: '/paginaOkTemplate/seccion/:seccionId?',
    Component: lazy(() => import('pages/paginaOkTemplate/seccion')),
    exact: true,
  },

  // Mail Template
  {
    keyMenu: 'mails',
    path: '/mailTemplate/list',
    Component: lazy(() => import('pages/mailTemplate/list')),
    exact: true,
  },
  {
    keyMenu: 'mails',
    path: '/mailTemplate/pagina/:mailTemplateId?',
    Component: lazy(() => import('pages/mailTemplate/pagina')),
    exact: true,
  },

  // Ventas
  {
    keyMenu: 'ventas',
    path: '/ventas/list',
    Component: lazy(() => import('pages/ventas/list')),
    exact: true,
  },
  {
    keyMenu: 'ventas',
    path: '/ventas/edit/:id?',
    Component: lazy(() => import('pages/ventas/insert')),
    exact: true,
  },
  {
    keyMenu: 'ventas',
    path: '/ventas/create',
    Component: lazy(() => import('pages/ventas/insert')),
    exact: true,
  },

  // Venta Masiva
  {
    keyMenu: 'ventasmasiva',
    path: '/ventasmasiva/list',
    Component: lazy(() => import('pages/ventasmasiva/list')),
    exact: true,
  },

  // Venta Cambio Estado
  {
    keyMenu: 'ventascambioestado',
    path: '/cambiarEstadoVentas/list',
    Component: lazy(() => import('pages/cambiarEstadoVentas/list')),
    exact: true,
  },

  // Recogidas en tienda
  {
    keyMenu: 'recogidasTienda',
    path: '/ventas/recogidas-tienda',
    Component: lazy(() => import('pages/ventas/recogidasTienda')),
    exact: true,
  },

  // Devoluciones
  {
    keyMenu: 'devoluciones',
    path: '/devoluciones/list',
    Component: lazy(() => import('pages/devoluciones/list')),
    exact: true,
  },

  // Importar Amazon
  {
    keyMenu: 'amazon',
    path: '/ventas/amazon/list',
    Component: lazy(() => import('pages/ventas/amazon/list')),
    exact: true,
  },

  // Factura SII A3
  {
    keyMenu: 'facturasiia3',
    path: '/facturasSiiA3/list',
    Component: lazy(() => import('pages/facturasSiiA3/list')),
    exact: true,
  },

  // Cache
  {
    keyMenu: 'cache',
    path: '/cache/list',
    Component: lazy(() => import('pages/cache/list')),
    exact: true,
  },

  // Ladrones
  {
    keyMenu: 'ladrones',
    path: '/ladrones/list',
    Component: lazy(() => import('pages/ladrones/list')),
    exact: true,
  },

  // Estado
  {
    keyMenu: 'estados',
    path: '/estados/list',
    Component: lazy(() => import('pages/estados/list')),
    exact: true,
  },

  // Estado Bulto
  {
    keyMenu: 'estadosBultos',
    path: '/estadosBultos/list',
    Component: lazy(() => import('pages/estadosBultos/list')),
    exact: true,
  },

  // Estado Mensajeria
  {
    keyMenu: 'estadosMensajeria',
    path: '/estadosMensajeria/list',
    Component: lazy(() => import('pages/estadosMensajeria/list')),
    exact: true,
  },

  // Restricciones de Entrega
  {
    keyMenu: 'restriccionesEntrega',
    path: '/restriccionentrega/list',
    Component: lazy(() => import('pages/restriccionentrega/list')),
    exact: true,
  },
  {
    keyMenu: 'restriccionesEntrega',
    path: '/restriccionentrega/create',
    Component: lazy(() => import('pages/restriccionentrega/insert')),
    exact: true,
  },

  // Bandejas
  {
    keyMenu: 'verBandejas',
    path: '/bandejas/list',
    Component: lazy(() => import('pages/bandejas/list')),
    exact: true,
  },

  // Estanterias
  {
    keyMenu: 'estanteriasCrear',
    path: '/estanterias/list',
    Component: lazy(() => import('pages/estanterias/insert')),
    exact: true,
  },

  // Tildar Bandejas
  {
    keyMenu: 'tildarBandejas',
    path: '/estanterias/tildar',
    Component: lazy(() => import('pages/estanterias/arriba')),
    exact: true,
  },

  // Separar personalizado
  {
    keyMenu: 'separar-personalizado',
    path: '/estanterias/separar-personalizado',
    Component: lazy(() => import('pages/estanterias/abajo')),
    exact: true,
  },

  // Diseño Mixta
  {
    keyMenu: 'estanteria-diseno-mixta',
    path: '/estanterias/estanteria-diseno-mixta',
    Component: lazy(() => import('pages/estanterias/mixta')),
    exact: true,
  },

  // Control Diseño
  {
    keyMenu: 'control-diseno',
    path: '/control-diseno/control',
    Component: lazy(() => import('pages/controlDiseno')),
    exact: true,
  },

  {
    keyMenu: 'control-diseno',
    path: '/control-diseno/control/:id?',
    Component: lazy(() => import('pages/controlDiseno')),
    exact: true,
  },

  // Control Diseño mantas
  {
    keyMenu: 'control-diseno-mantas',
    path: '/control-diseno-mantas/list',
    Component: lazy(() => import('pages/controlDisenoMantas/list')),
    exact: true,
  },

  // Usuarios Admin
  {
    keyMenu: 'Usuarios',
    path: '/usuariosAdmin/usuarios/list',
    Component: lazy(() => import('pages/usuariosAdmin/usuarios/list')),
    exact: true,
  },
  {
    keyMenu: 'Usuarios',
    path: '/usuariosAdmin/usuarios/edit/:id?',
    Component: lazy(() => import('pages/usuariosAdmin/usuarios/insert')),
    exact: true,
  },
  {
    keyMenu: 'Usuarios',
    path: '/usuariosAdmin/usuarios/create',
    Component: lazy(() => import('pages/usuariosAdmin/usuarios/insert')),
    exact: true,
  },
  {
    keyMenu: 'Usuarios',
    path: '/usuariosAdmin/usuarios/asignarMenu/:id?',
    Component: lazy(() => import('pages/usuariosAdmin/usuarios/asignarMenu')),
    exact: true,
  },

  // Usuario perfil
  {
    keyMenu: '', // Esta key es genericay de uso para todos lo usuarios
    path: '/usuariosAdmin/profile/list',
    Component: lazy(() => import('pages/usuariosAdmin/profile/list')),
    exact: true,
  },

  // Estados Usuarios
  {
    keyMenu: 'estadoUsuarios',
    path: '/estadosUsuarios/list',
    Component: lazy(() => import('pages/estadosUsuarios/list')),
    exact: true,
  },

  // Dhl
  // Misma pantalla en dos rutas con keyMenu propia cada una, para que los permisos se puedan
  // conceder por separado. El modo llega por la config de ruta, igual que urlGrupos /
  // urlGruposDiseno con tipoGrupo.
  {
    keyMenu: 'dhlAereoTransmitir',
    path: '/dhl/list/aereo',
    Component: lazy(() => import('pages/dhl/list')),
    exact: true,
    props: { modo: 'aereo' },
  },
  {
    keyMenu: 'dhlTerrestreTransmitir',
    path: '/dhl/list/terrestre',
    Component: lazy(() => import('pages/dhl/list')),
    exact: true,
    props: { modo: 'terrestre' },
  },

  // Seur
  {
    keyMenu: 'seurTransmitir',
    path: '/seur/list',
    Component: lazy(() => import('pages/seur/list')),
    exact: true,
  },

  // Correos Express
  {
    keyMenu: 'correosExpressTransmitir',
    path: '/correosExpress/list',
    Component: lazy(() => import('pages/correosExpress/list')),
    exact: true,
  },

  // Mrw CLick
  {
    keyMenu: 'mrwTransmitirDiurno',
    path: '/mrwClick/list/:tipo?',
    Component: lazy(() => import('pages/mrwClick/list')),
    exact: true,
  },
  // Nacex
  {
    keyMenu: 'nacexTransmitir',
    path: '/nacex/list',
    Component: lazy(() => import('pages/nacex/list')),
    exact: true,
  },
  // Imprimir etiquetas ZPL (menu en Usuario.API/Infrastructure/Sql/Insert_Menu_ImprimirEtiquetasZpl.sql)
  {
    keyMenu: 'imprimirEtiquetasZpl',
    path: '/mensajeria/imprimir-etiquetas-zpl',
    Component: lazy(() => import('pages/mensajeria/imprimirEtiquetasZpl')),
    exact: true,
  },

  /*
  // Ecommerce
  {
    path: '/ecommerce/dashboard',
    Component: lazy(() => import('pages/ecommerce/dashboard')),
    exact: true,
  },
  {
    path: '/ecommerce/orders',
    Component: lazy(() => import('pages/ecommerce/orders')),
    exact: true,
  },
  {
    path: '/ecommerce/product-catalog',
    Component: lazy(() => import('pages/ecommerce/product-catalog')),
    exact: true,
  },
  {
    path: '/ecommerce/product-details',
    Component: lazy(() => import('pages/ecommerce/product-details')),
    exact: true,
  },
  {
    path: '/ecommerce/cart',
    Component: lazy(() => import('pages/ecommerce/cart')),
    exact: true,
  },
  
  // Apps
  {
    path: '/apps/messaging',
    Component: lazy(() => import('pages/apps/messaging')),
    exact: true,
  },
  {
    path: '/apps/calendar',
    Component: lazy(() => import('pages/apps/calendar')),
    exact: true,
  },
  {
    path: '/apps/mail',
    Component: lazy(() => import('pages/apps/mail')),
    exact: true,
  },
  {
    path: '/apps/profile',
    Component: lazy(() => import('pages/apps/profile')),
    exact: true,
  },
  {
    path: '/apps/gallery',
    Component: lazy(() => import('pages/apps/gallery')),
    exact: true,
  },

  // Extra Apps
  {
    path: '/apps/github-explore',
    Component: lazy(() => import('pages/apps/github-explore')),
    exact: true,
  },
  {
    path: '/apps/github-discuss',
    Component: lazy(() => import('pages/apps/github-discuss')),
    exact: true,
  },
  {
    path: '/apps/digitalocean-droplets',
    Component: lazy(() => import('pages/apps/digitalocean-droplets')),
    exact: true,
  },
  {
    path: '/apps/digitalocean-create',
    Component: lazy(() => import('pages/apps/digitalocean-create')),
    exact: true,
  },
  {
    path: '/apps/google-analytics',
    Component: lazy(() => import('pages/apps/google-analytics')),
    exact: true,
  },
  {
    path: '/apps/wordpress-post',
    Component: lazy(() => import('pages/apps/wordpress-post')),
    exact: true,
  },
  {
    path: '/apps/wordpress-posts',
    Component: lazy(() => import('pages/apps/wordpress-posts')),
    exact: true,
  },
  {
    path: '/apps/wordpress-add',
    Component: lazy(() => import('pages/apps/wordpress-add')),
    exact: true,
  },
  {
    path: '/apps/todoist-list',
    Component: lazy(() => import('pages/apps/todoist-list')),
    exact: true,
  },
  {
    path: '/apps/jira-dashboard',
    Component: lazy(() => import('pages/apps/jira-dashboard')),
    exact: true,
  },
  {
    path: '/apps/jira-agile-board',
    Component: lazy(() => import('pages/apps/jira-agile-board')),
    exact: true,
  },
  {
    path: '/apps/helpdesk-dashboard',
    Component: lazy(() => import('pages/apps/helpdesk-dashboard')),
    exact: true,
  },

  // Widgets
  {
    path: '/widgets/general',
    Component: lazy(() => import('pages/widgets/general')),
    exact: true,
  },
  {
    path: '/widgets/lists',
    Component: lazy(() => import('pages/widgets/lists')),
    exact: true,
  },
  {
    path: '/widgets/tables',
    Component: lazy(() => import('pages/widgets/tables')),
    exact: true,
  },
  {
    path: '/widgets/charts',
    Component: lazy(() => import('pages/widgets/charts')),
    exact: true,
  },


  // Cards
  {
    path: '/cards/basic-cards',
    Component: lazy(() => import('pages/cards/basic-cards')),
    exact: true,
  },
  {
    path: '/cards/tabbed-cards',
    Component: lazy(() => import('pages/cards/tabbed-cards')),
    exact: true,
  },
  // UI Kits
  {
    path: '/ui-kits/bootstrap',
    Component: lazy(() => import('pages/ui-kits/bootstrap')),
    exact: true,
  },
  {
    path: '/ui-kits/antd',
    Component: lazy(() => import('pages/ui-kits/antd')),
    exact: true,
  },
  
  // Tables
  {
    path: '/tables/bootstrap',
    Component: lazy(() => import('pages/tables/bootstrap')),
    exact: true,
  },
  {
    path: '/tables/antd',
    Component: lazy(() => import('pages/tables/antd')),
    exact: true,
  },

  // Charts
  {
    path: '/charts/chartistjs',
    Component: lazy(() => import('pages/charts/chartistjs')),
    exact: true,
  },
  {
    path: '/charts/chartjs',
    Component: lazy(() => import('pages/charts/chartjs')),
    exact: true,
  },
  {
    path: '/charts/c3',
    Component: lazy(() => import('pages/charts/c3')),
    exact: true,
  },

  // Advanced
  {
    path: '/advanced/form-examples',
    Component: lazy(() => import('pages/advanced/form-examples')),
    exact: true,
  },
  {
    path: '/advanced/email-templates',
    Component: lazy(() => import('pages/advanced/email-templates')),
    exact: true,
  },
  {
    path: '/advanced/utilities',
    Component: lazy(() => import('pages/advanced/utilities')),
    exact: true,
  },
  {
    path: '/advanced/grid',
    Component: lazy(() => import('pages/advanced/grid')),
    exact: true,
  },
  {
    path: '/advanced/typography',
    Component: lazy(() => import('pages/advanced/typography')),
    exact: true,
  },
  {
    path: '/advanced/pricing-tables',
    Component: lazy(() => import('pages/advanced/pricing-tables')),
    exact: true,
  },
  {
    path: '/advanced/invoice',
    Component: lazy(() => import('pages/advanced/invoice')),
    exact: true,
  },
  {
    path: '/advanced/colors',
    Component: lazy(() => import('pages/advanced/colors')),
    exact: true,
  },
  */

  // Icons
  {
    keyMenu: '', // Esta key es genericay de uso para todos lo usuarios
    path: '/icons/feather-icons',
    Component: lazy(() => import('pages/icons/feather-icons')),
    exact: true,
  },
  {
    keyMenu: '', // Esta key es genericay de uso para todos lo usuarios
    path: '/icons/fontawesome',
    Component: lazy(() => import('pages/icons/fontawesome')),
    exact: true,
  },
  {
    keyMenu: '', // Esta key es genericay de uso para todos lo usuarios
    path: '/icons/linearicons-free',
    Component: lazy(() => import('pages/icons/linearicons-free')),
    exact: true,
  },
  {
    keyMenu: '', // Esta key es genericay de uso para todos lo usuarios
    path: '/icons/icomoon-free',
    Component: lazy(() => import('pages/icons/icomoon-free')),
    exact: true,
  },

  // Bibliotecas Prediseños SVG
  {
    keyMenu: 'bibliotecasPredSvg',
    path: '/bibpredsvg/list',
    Component: lazy(() => import('pages/bibpredsvg/list')),
    exact: true,
  },
  {
    keyMenu: 'bibliotecasPredSvg',
    path: '/bibpredsvg/edit/:id?',
    Component: lazy(() => import('pages/bibpredsvg/insert')),
    exact: true,
  },
  {
    keyMenu: 'bibliotecasPredSvg',
    path: '/bibpredsvg/create',
    Component: lazy(() => import('pages/bibpredsvg/insert')),
    exact: true,
  },

  // Asociar Bibliotecas PredSvg a Productos
  {
    keyMenu: 'productos',
    path: '/productosBibliotecasPredSvg/:id?',
    Component: lazy(() => import('pages/productosBibliotecasPredSvg/edit')),
    exact: true,
  },

  // Bibliotecas de Plantillas
  {
    keyMenu: 'bibliotecasPlantillas',
    path: '/bibplantilla/list',
    Component: lazy(() => import('pages/bibplantilla/list')),
    exact: true,
  },
  {
    keyMenu: 'bibliotecasPlantillas',
    path: '/bibplantilla/create',
    Component: lazy(() => import('pages/bibplantilla/insert')),
    exact: true,
  },
  {
    keyMenu: 'bibliotecasPlantillas',
    path: '/bibplantilla/edit/:id?',
    Component: lazy(() => import('pages/bibplantilla/insert')),
    exact: true,
  },

  // Asociar Bibliotecas Plantillas a Productos
  {
    keyMenu: 'productos',
    path: '/productosBibliotecasPlantillas/:id?',
    Component: lazy(() => import('pages/productosBibliotecasPlantillas/edit')),
    exact: true,
  },

  // Combos SVG
  {
    keyMenu: 'combosSvg',
    path: '/combossvg/edit/:id?',
    Component: lazy(() => import('pages/combossvg/insert')),
    exact: true,
  },
  {
    keyMenu: 'combosSvg',
    path: '/combossvg/list',
    Component: lazy(() => import('pages/combossvg/list')),
    exact: true,
  },
  {
    keyMenu: 'combosSvg',
    path: '/combossvg/create',
    Component: lazy(() => import('pages/combossvg/insert')),
    exact: true,
  },

  // Asociar Combos SVG a Productos
  {
    keyMenu: 'productos',
    path: '/productosCombosSvg/:id?',
    Component: lazy(() => import('pages/productosCombosSvg/edit')),
    exact: true,
  },

  // Editar orden de Combo SVG para un producto en concreto
  {
    keyMenu: 'productos',
    path: '/productosCombosSvgEdit/:idProducto?/:idComboSvg?',
    Component: lazy(() => import('pages/productosCombosSvgEdit')),
    exact: true,
  },

  // Impresión de diseños SVG
  {
    keyMenu: '',
    path: '/impresionBibliotecasSvg/:disenoSvgId?',
    Component: lazy(() => import('pages/impresionDisenoCliente/bibliotecasSvg')),
    exact: true,
  },

  // Bibliotecas de Preguntas
  {
    keyMenu: 'bibliotecasPreguntas',
    path: '/bibpregunta/list',
    Component: lazy(() => import('pages/bibpregunta/list')),
    exact: true,
  },
  {
    keyMenu: 'bibliotecasPreguntas',
    path: '/bibpregunta/create',
    Component: lazy(() => import('pages/bibpregunta/insert')),
    exact: true,
  },
  {
    keyMenu: 'bibliotecasPreguntas',
    path: '/bibpregunta/edit/:id?',
    Component: lazy(() => import('pages/bibpregunta/insert')),
    exact: true,
  },

  // Asociar Bibliotecas Plantillas a Productos
  {
    keyMenu: 'productos',
    path: '/productosBibliotecaPreguntas/:id?',
    Component: lazy(() => import('pages/productosBibliotecaPreguntas/edit')),
    exact: true,
  },

  // Bibliotecas de Familias
  {
    keyMenu: 'bibliotecasFamilias',
    path: '/bibfamilia/list',
    Component: lazy(() => import('pages/bibfamilia/list')),
    exact: true,
  },
  {
    keyMenu: 'bibliotecasFamilias',
    path: '/bibfamilia/edit/:id?',
    Component: lazy(() => import('pages/bibfamilia/insert')),
    exact: true,
  },
  {
    keyMenu: 'bibliotecasFamilias',
    path: '/bibfamilia/ordenarPegatinas/:biblitecaid?',
    Component: lazy(() => import('pages/bibfamilia/insert/ordenarPegatinas')),
    exact: true,
  },

  // Bibliotecas Fondos Familias
  {
    keyMenu: 'bibliotecasFamiliasFondos',
    path: '/bibfondofamilia/list',
    Component: lazy(() => import('pages/bibfondofamilia/list')),
    exact: true,
  },
  {
    keyMenu: 'bibliotecasFamiliasFondos',
    path: '/bibfondofamilia/edit/:id?',
    Component: lazy(() => import('pages/bibfondofamilia/insert')),
    exact: true,
  },

  // Asociar Bibliotecas Plantillas a Productos
  {
    keyMenu: 'productos',
    path: '/productosBibliotecaFamilia/:id?',
    Component: lazy(() => import('pages/productosBibliotecaFamilia/edit')),
    exact: true,
  },

  // Asociar Chocomensajes a Productos
  {
    keyMenu: 'productos',
    path: '/productosChocomensaje/:id?',
    Component: lazy(() => import('pages/productosChocomensaje/edit')),
    exact: true,
  },

  // Colores lego
  {
    keyMenu: 'coloresLego',
    path: '/colorlego/list',
    Component: lazy(() => import('pages/colorlego/list')),
    exact: true,
  },

  // Categorias stickers
  {
    keyMenu: 'categoriasStickers',
    path: '/stickers/categorias/list',
    Component: lazy(() => import('pages/stickers/categorias/list')),
    exact: true,
  },

  {
    keyMenu: 'categoriasStickers',
    path: '/stickers/categoria/:id?',
    Component: lazy(() => import('pages/stickers/list')),
    exact: true,
  },

  // Fonts
  {
    keyMenu: 'tipoLetras',
    path: '/fonts/list',
    Component: lazy(() => import('pages/fonts/list')),
    exact: true,
  },
  {
    keyMenu: 'tipoLetras',
    path: '/fonts/create',
    Component: lazy(() => import('pages/fonts/insert')),
    exact: true,
  },
  {
    keyMenu: 'tipoLetras',
    path: '/fonts/edit/:id?',
    Component: lazy(() => import('pages/fonts/insert')),
    exact: true,
  },

  // Biblioteca de Precios
  {
    keyMenu: 'bibliotecasPrecios',
    path: '/bibprecios/list',
    Component: lazy(() => import('pages/bibprecios/list')),
    exact: true,
  },
  {
    keyMenu: 'bibliotecasPrecios',
    path: '/bibprecios/create',
    Component: lazy(() => import('pages/bibprecios/insert')),
    exact: true,
  },
  {
    keyMenu: 'bibliotecasPrecios',
    path: '/bibprecios/edit/:id?',
    Component: lazy(() => import('pages/bibprecios/insert')),
    exact: true,
  },
  {
    keyMenu: 'bibliotecasPrecios',
    path: '/bibprecios/editarProductos/:id?',
    Component: lazy(() => import('pages/bibprecios/bibpreciosProductos/list')),
    exact: true,
  },

  // Reportes
  {
    keyMenu: 'productosPreparados',
    path: '/repostes/productos-preparados/',
    Component: lazy(() => import('pages/reportes/productosPreparados')),
    exact: true,
  },
  {
    keyMenu: 'registrosPedidos',
    path: '/reportes/registros-pedidos/',
    Component: lazy(() => import('pages/reportes/registrosPedidos')),
    exact: true,
  },
  {
    keyMenu: 'usuariosVentaPreparados',
    path: '/reportes/usuarios-venta-preparados/',
    Component: lazy(() => import('pages/reportes/usuariosVentaPreparados')),
    exact: true,
  },
  {
    keyMenu: 'usuariosVentaBandeja',
    path: '/reportes/usuarios-venta-bandeja/',
    Component: lazy(() => import('pages/reportes/usuariosVentaBandeja')),
    exact: true,
  },
  {
    keyMenu: 'checkBultos',
    path: '/reportes/check-bultos/',
    Component: lazy(() => import('pages/bultos/check')),
    exact: true,
  },
  {
    keyMenu: 'tildarBultos',
    path: '/reportes/tildar-bultos/',
    Component: lazy(() => import('pages/bultos/check')),
    exact: true,
  },
  {
    keyMenu: 'etiquetasComidas',
    path: '/reportes/etiquetasComidas/list',
    Component: lazy(() => import('pages/reportes/etiquetasComidas/list')),
    exact: true,
  },
  {
    keyMenu: 'compararfacturacion',
    path: '/reportes/compararfacturacion/list',
    Component: lazy(() => import('pages/reportes/compararfacturacion/list')),
    exact: true,
  },
  {
    keyMenu: 'lotesImpresion',
    path: '/reportes/lotes-impresion/list',
    Component: lazy(() => import('pages/lotesimpresion/list')),
    exact: true,
  },
  {
    keyMenu: 'listadofaltantes',
    path: '/reportes/listadoFaltantes/list',
    Component: lazy(() => import('pages/reportes/listadoFaltantes/list')),
    exact: true,
  },
  {
    keyMenu: 'listadofrutaspendientescompra',
    path: '/reportes/listadoFrutasPendientesCompra/list',
    Component: lazy(() => import('pages/reportes/listadoFrutasPendientesCompra/list')),
    exact: true,
  },
  {
    keyMenu: 'listadoproductoramosvendidos',
    path: '/reportes/listado-producto-ramos-vendidos/list',
    Component: lazy(() => import('pages/reportes/productosRamosVendidos/list')),
    exact: true,
  },
  {
    keyMenu: 'listadoproductovendidos',
    path: '/reportes/listado-producto-vendidos/list',
    Component: lazy(() => import('pages/reportes/productosVendidos/list')),
    exact: true,
  },
  {
    keyMenu: 'listadoproductovendidosurl',
    path: '/reportes/listado-producto-vendidos-url/list',
    Component: lazy(() => import('pages/reportes/productosVendidosUrl/list')),
    exact: true,
  },
  {
    keyMenu: 'listadoproductofabricados',
    path: '/reportes/listado-productos-fabricados/list',
    Component: lazy(() => import('pages/reportes/productosFabricados/list')),
    exact: true,
  },
  {
    keyMenu: 'listadourlactivasnotraducidas',
    path: '/reportes/listado-url-activas-no-traducidas/list',
    Component: lazy(() => import('pages/reportes/listadoUrlActivasNoTraducidas/list')),
    exact: true,
  },
  {
    keyMenu: 'estantesincompletos',
    path: '/estantesIncompletos/list',
    Component: lazy(() => import('pages/estantesIncompletos/list')),
    exact: true,
  },

  // Reclamaciones
  {
    keyMenu: 'mrwReclamaciones',
    path: '/reclamaciones-mrw/',
    Component: lazy(() => import('pages/reclamacionesMrw')),
    exact: true,
  },

  // Avatares
  {
    keyMenu: 'listaAvatares',
    path: '/avatares/list',
    Component: lazy(() => import('pages/avatares/biblioteca/list')),
    exact: true,
  },
  {
    keyMenu: 'listaAvatares',
    path: '/avatares/create',
    Component: lazy(() => import('pages/avatares/biblioteca/insert')),
    exact: true,
  },
  {
    keyMenu: 'listaAvatares',
    path: '/avatares/edit/:id?',
    Component: lazy(() => import('pages/avatares/biblioteca/insert')),
    exact: true,
  },
  {
    keyMenu: 'listaAvatares',
    path: '/avatares/modelo/:id?',
    Component: lazy(() => import('pages/avatares/biblioteca/modelo')),
    exact: true,
  },

  // Avatares Colores
  {
    keyMenu: 'coloresAvatares',
    path: '/avatares/paleta/list',
    Component: lazy(() => import('pages/avatares/paleta/list')),
    exact: true,
  },

  // Avatares Secciones
  {
    keyMenu: 'seccionesAvatares',
    path: '/avatares/seccion/list',
    Component: lazy(() => import('pages/avatares/seccion/list')),
    exact: true,
  },
  {
    keyMenu: 'seccionesAvatares',
    path: '/avatares/seccion/create',
    Component: lazy(() => import('pages/avatares/seccion/insert')),
    exact: true,
  },
  {
    keyMenu: 'seccionesAvatares',
    path: '/avatares/seccion/edit/:id?',
    Component: lazy(() => import('pages/avatares/seccion/insert')),
    exact: true,
  },

  // Avatates tamaño
  {
    keyMenu: 'sizeAvatares',
    path: '/avatares/size/list',
    Component: lazy(() => import('pages/avatares/size/list')),
    exact: true,
  },

  // Avatares Galeria de clientes
  {
    keyMenu: 'clienteAvatares',
    path: '/avatares/cliente/list',
    Component: lazy(() => import('pages/avatares/cliente/list')),
    exact: true,
  },

  // Avatares Galeria lista avatares
  {
    keyMenu: 'listaAvatares',
    path: '/avatares/galeria/list/:id?/:_section?/:_size?',
    Component: lazy(() => import('pages/avatares/galeria/list')),
    exact: true,
  },
  {
    keyMenu: 'listaAvatares',
    path: '/avatares/galeria/masivo/:id?',
    Component: lazy(() => import('pages/avatares/galeria/masivo')),
    exact: true,
  },

  // Avatares plantillas
  {
    keyMenu: 'templateAvatares',
    path: '/avatares/plantilla/list',
    Component: lazy(() => import('pages/avatares/plantilla/list')),
    exact: true,
  },
  {
    keyMenu: 'templateAvatares',
    path: '/avatares/plantilla/create',
    Component: lazy(() => import('pages/avatares/plantilla/insert')),
    exact: true,
  },
  {
    keyMenu: 'templateAvatares',
    path: '/avatares/plantilla/edit/:id?',
    Component: lazy(() => import('pages/avatares/plantilla/insert')),
    exact: true,
  },

  // Avatares capas
  {
    keyMenu: 'layerAvatares',
    path: '/avatares/layer/list',
    Component: lazy(() => import('pages/avatares/layer/list')),
    exact: true,
  },

  // Avatares stock piezas
  {
    keyMenu: 'stockPiezas',
    path: '/avatares/piezas/list',
    Component: lazy(() => import('pages/avatares/piezas/list')),
    exact: true,
  },

  // Mensajeros
  {
    keyMenu: 'mensajeros',
    path: '/mensajeros/list',
    Component: lazy(() => import('pages/mensajeros/list')),
    exact: true,
  },

  // Mensajeros recorrido
  {
    keyMenu: 'recorridos',
    path: '/mensajeros/recorridos',
    Component: lazy(() => import('pages/mensajeros/recorridos')),
    exact: true,
  },

  // Mesajero separar pedidos
  {
    keyMenu: 'separarPedidos',
    path: '/mensajeros/separarPedidos',
    Component: lazy(() => import('pages/mensajeros/separarPedidos')),
    exact: true,
  },
  // Histórico de recorridos de mensajeros
  {
    keyMenu: 'historicoRecorridos',
    path: '/mensajeros/historico',
    Component: lazy(() => import('pages/mensajeros/historico')),
    exact: true,
  },
  {
    // La key del menú tiene la errata "descriocionesIva"; es la que se asigna en los permisos
    keyMenu: 'descriocionesIva',
    path: '/descripcionesIva/list',
    Component: lazy(() => import('pages/descripcionesIva/list')),
    exact: true,
  },

  // Productos Mas Vendidos
  {
    keyMenu: 'productosMasVendidos',
    path: '/productosMasVendidos/',
    Component: lazy(() => import('pages/productosMasVendidos')),
    exact: true,
  },

  // Jobs
  {
    keyMenu: 'jobs',
    path: '/jobs/list',
    Component: lazy(() => import('pages/jobs/management')),
    exact: true,
  },
  {
    keyMenu: 'jobs',
    path: '/jobs/management',
    Component: lazy(() => import('pages/jobs/management')),
    exact: true,
  },

  // Departamentos
  {
    keyMenu: 'departamentos',
    path: '/departamentos/list',
    Component: lazy(() => import('pages/departamentos/list')),
    exact: true,
  },

  // Roles
  {
    keyMenu: 'roles',
    path: '/roles/list',
    Component: lazy(() => import('pages/usuariosAdmin/roles/list')),
    exact: true,
  },
  {
    keyMenu: 'roles',
    path: '/roles/menuEdit/:id?',
    Component: lazy(() => import('pages/usuariosAdmin/roles/menuEdit')),
    exact: true,
  },

  // Firewall IP
  {
    keyMenu: 'firewallip',
    path: '/firewallip/list',
    Component: lazy(() => import('pages/firewallip/list')),
    exact: true,
  },

  // AppSettings
  {
    keyMenu: 'appsettings',
    path: '/appSettings/insert',
    Component: lazy(() => import('pages/appSettings/insert')),
    exact: true,
  },

  // Sync
  {
    keyMenu: 'sync',
    path: '/sync/list',
    Component: lazy(() => import('pages/sync/list')),
    exact: true,
  },
  {
    keyMenu: 'ventaSyncStatus',
    path: '/sync/ventaSyncStatus/list',
    Component: lazy(() => import('pages/sync/ventaSyncStatus')),
    exact: true,
  },

  // Email gateway
  {
    keyMenu: 'emailGatewayCampanas',
    path: '/email-gateway/campanas',
    Component: lazy(() => import('pages/emailGateway/campanas')),
    exact: true,
  },
  {
    keyMenu: 'emailGatewayCampanas',
    path: '/email-gateway/campanas/:id',
    Component: lazy(() => import('pages/emailGateway/campanas/detalle')),
    exact: true,
  },
  {
    keyMenu: 'emailGatewaySupresiones',
    path: '/email-gateway/supresiones',
    Component: lazy(() => import('pages/emailGateway/supresiones')),
    exact: true,
  },
  {
    keyMenu: 'emailGatewayConsumidores',
    path: '/email-gateway/consumidores',
    Component: lazy(() => import('pages/emailGateway/consumidores')),
    exact: true,
  },

  // Reseñas (las entradas de menú "Aprobar reviews" y "Reviews" ya existen en usuario.Menu con estas urls)
  {
    keyMenu: 'aprobarreviews',
    path: '/aprobarreviews/list',
    Component: lazy(() => import('pages/reviews/aprobar')),
    exact: true,
  },
  {
    keyMenu: 'reviews',
    path: '/reviews/list',
    Component: lazy(() => import('pages/reviews/importar')),
    exact: true,
  },
]

const mapStateToProps = ({ settings, usuarioReducer }) => ({
  routerAnimation: settings.routerAnimation,
  usuarioMenuKeys: usuarioReducer.usuarioMenuKeys,
})

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadListadoMenuUsuario: (usuarioId) => {
      getListadoMenuByUsuarioIdAction(dispatch, usuarioId)
    },
    onLoadListadoMenuKeysUsuario: (usuarioId) => {
      getPermisosMenuKeyUsuarioByIdAction(dispatch, usuarioId)
    },
  }
}

const RouteMenuKeySync = ({ keyMenu, children }) => {
  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent('app:route-key-menu', {
        detail: { keyMenu: keyMenu || '' },
      }),
    )
  }, [keyMenu])

  return children
}

const Router = ({
  history,
  routerAnimation,
  onLoadListadoMenuUsuario,
  onLoadListadoMenuKeysUsuario,
}) => {
  const { accounts } = useMsal()

  // Sin sesión no hay menú de usuario que cargar. Leer accounts[0] a pelo tumbaba la aplicación
  // entera en cuanto el array llegaba vacío, que es lo que pasa en la página de impresión de
  // diseños: se abre sin login para que la cargue el generador de diseños.
  const localAccountId = accounts[0]?.localAccountId

  useEffect(() => {
    if (!localAccountId) return

    onLoadListadoMenuUsuario(localAccountId)
  }, [localAccountId, onLoadListadoMenuUsuario])

  useEffect(() => {
    if (!localAccountId) return

    onLoadListadoMenuKeysUsuario(localAccountId)
  }, [localAccountId, onLoadListadoMenuKeysUsuario])

  const nodeRef = React.useRef(null)

  return (
    <ConnectedRouter history={history}>
      <Layout>
        <Route
          render={(state) => {
            const { location } = state
            return (
              <SwitchTransition>
                <CSSTransition
                  key={location.pathname}
                  appear
                  classNames={routerAnimation}
                  timeout={routerAnimation === 'none' ? 0 : 300}
                  nodeRef={nodeRef}
                >
                  <Switch location={location}>
                    <Route exact path="/" render={() => <Redirect to="/dashboard/regalo" />} />
                    {routes.map(({ path, Component, exact, props, keyMenu }) => (
                      <Route
                        path={path}
                        key={path}
                        exact={exact}
                        render={() => {
                          return (
                            <div className={routerAnimation}>
                              <ChunkErrorBoundary>
                                <Suspense fallback={null}>
                                  <RouteMenuKeySync keyMenu={keyMenu}>
                                    <ProtectedRoute keyMenu={keyMenu}>
                                      <Component {...props} />
                                    </ProtectedRoute>
                                  </RouteMenuKeySync>
                                </Suspense>
                              </ChunkErrorBoundary>
                            </div>
                          )
                        }}
                      />
                    ))}
                    <Redirect to="/auth/404" />
                  </Switch>
                </CSSTransition>
              </SwitchTransition>
            )
          }}
        />
      </Layout>
    </ConnectedRouter>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Router)
